module.exports = __webpack_public_path__ + "img/SE.69d5630f.svg";